// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderVerticleOutlinedSvg from "@fishx/icons-svg/es/asn/BorderVerticleOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderVerticleOutlined = function BorderVerticleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderVerticleOutlinedSvg
  }));
};

BorderVerticleOutlined.displayName = 'BorderVerticleOutlined';
export default React.forwardRef(BorderVerticleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderVerticleOutlined.js
// module id = 2108
// module chunks = 0